import { api } from ".";

export async function fetchEventSummary(date:string, phase:string) {
  const response = await api.get("/eventSummary", { params: { date, phase }});

  return response.data;
}